import React, { useMemo } from 'react';
import { Table, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CallEmptyState from './CallEmptyState';
import PatientCallsEmptyState from '../patient/PatientCallsEmptyState';

const { Text } = Typography;

export default function CallList({
                                   calls,
                                   pagination,
                                   onPageChange = () => {},
                                   fromPatientDetails = false
                                 }) {
  const { t } = useTranslation();

  const truncateText = (text) => (text?.length > 200 ? `${text.substring(0, 200)}...` : text);

  const buildCallLink = (record) => {
    const basePath = `/calls/${record.getUUID()}`;
    const searchParams = new URLSearchParams();

    if (!record.isReady() && record.isGenerating()) searchParams.set('generating', '1');

    return searchParams.toString() ? `${basePath}?${searchParams.toString()}` : basePath;
  };

  const baseColumns = [
    {
      title: '',
      dataIndex: 'title',
      key: 'title',
      render: (_, record) =>
        record.isReady() ? (
          <Link to={buildCallLink(record)}>{record.getTitle(fromPatientDetails)}</Link>
        ) : record.isGenerating() ? (
          <Link to={buildCallLink(record)}>{t('recent_calls.generating')}</Link>
        ) : (
          <>
            <div><Text>{record.getDisplayStatus()}</Text></div>
            <Text type="secondary">{record.getDisplayProblem()}</Text>
          </>
        ),
      onCell: () => ({ style: { minWidth: 200 } })
    },
    {
      title: '',
      dataIndex: 'excerpt',
      key: 'excerpt',
      responsive: ['lg'],
      render: (_, record) => <Text>{truncateText(record.getExcerpt())}</Text>,
    },
    {
      title: '',
      dataIndex: 'time',
      key: 'time',
      responsive: ['md'],
      render: (_, record) => (
        <div className="markdown-content">{truncateText(record.getTime())}</div>
      ),
      onCell: () => ({ style: { minWidth: 150 } })
    }
  ];

  const toNumberColumn = {
    title: t('recent_calls.header'),
    dataIndex: 'to_number',
    key: 'to_number',
    responsive: ['md'],
    render: (_, record) => record.getToNumber(),
    onCell: () => ({ style: { minWidth: 150 } }),
  };

  const columns = useMemo(() => {
    return fromPatientDetails ? baseColumns : [toNumberColumn, ...baseColumns];
  }, [fromPatientDetails, t]);

  if (calls.length === 0) {
    return fromPatientDetails ? <PatientCallsEmptyState /> : <CallEmptyState />;
  }

  return (
    <Table
      showHeader={false}
      columns={columns}
      dataSource={calls}
      rowKey={(record) => record.getUUID()}
      pagination={
        pagination?.total > pagination.pageSize
          ? { ...pagination, position: ['bottomCenter'] }
          : false
      }
      onChange={(pagination) => onPageChange(pagination.current)}
    />
  );
}